import * as React from "react";
const SvgFiRrPointOfSaleSignal = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-point-of-sale-signal_svg__a)">
      <path
        fill="#062147"
        d="M8.5 8H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h1.5c.265 0 .52.105.707.293l2 2A1 1 0 0 1 8.5 8M6 10H5a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2m0 4H5a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2m7 2h1a1 1 0 0 0 0-2h-1a1 1 0 0 0 0 2m-3-6H9a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2m0 4H9a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2m-4 4H5a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2m7 2h1a1 1 0 0 0 0-2h-1a1 1 0 0 0 0 2m-3-2H9a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2m9-5h-1a1 1 0 0 0-1 1v5c0 1.654-1.346 3-3 3H5c-1.654 0-3-1.346-3-3V5c0-1.654 1.346-3 3-3h4a1 1 0 0 0 0-2H5C2.243 0 0 2.243 0 5v14c0 2.757 2.243 5 5 5h9a5.01 5.01 0 0 0 4.899-4H19a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1m-5.602-7.8A1 1 0 0 0 14.6 6.798a4.01 4.01 0 0 1 4.799 0 1 1 0 0 0 1.4-.198 1 1 0 0 0-.198-1.4 6.02 6.02 0 0 0-7.203 0m9.888-2.978c-3.643-2.953-8.932-2.952-12.574 0a1 1 0 1 0 1.259 1.553c2.914-2.36 7.142-2.361 10.056 0a.996.996 0 0 0 1.406-.148 1 1 0 0 0-.147-1.405m-4.787 7.277a1.5 1.5 0 1 0-3.001.001 1.5 1.5 0 0 0 3.001-.001"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-point-of-sale-signal_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPointOfSaleSignal;
